<template>
  <template v-if="!loading && detail">
    <formations-details-main
      v-bind:detail="detail"
      v-bind:open_elearning_module="openElearningModule"
      v-bind:open_map_modal="openMapModal" />
    <refonte-collapse
      v-if="detail.titre"
      class="mt-[12px]"
      v-bind:title_icon="IconMyAccount"
      title="Synthèse"
      v-bind:start_open="true">
      <refonte-table
        key="detail-1"
        table_index="detail-1"
        v-bind:columns="columnsSynthese"
        v-bind:data="[detail.synthese]">
      </refonte-table>
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.infosParticulieresProduit"
      class="mt-[12px]"
      v-bind:title_icon="IconInformation"
      title="Informations importantes"
      v-bind:start_open="true">
      <div
        class="ml-[20px] p-2"
        v-html="detail.infosParticulieresProduit" />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && (detail.convocation || detail.attestationId)"
      class="mt-[12px]"
      v-bind:title_icon="IconTestValidation"
      title="Documents"
      v-bind:start_open="true">
      <div class="flex flex-wrap gap-[8px] pb-[12px]">
        <refonte-item-file
          v-if="detail.convocation"
          id="convocation"
          title="Convocation"
          v-bind:on_click_download="openConvocationModal"
          v-bind:no_signature_needed="true" />
        <refonte-item-file
          v-if="detail.attestationId"
          id="attestation"
          title="Attestation"
          v-bind:on_click_download="
            () => {
              downloadAttestationParticipant(detail?.attestationId);
            }
          "
          v-bind:no_signature_needed="true" />
      </div>
    </refonte-collapse>

    <refonte-collapse
      v-if="
        detail.titre &&
        detail?.moduleElearning?.cours &&
        detail?.moduleElearning?.cours?.length > 0
      "
      class="mt-[12px]"
      v-bind:title_icon="IconCatalogue"
      title="Chapitres elearning"
      v-bind:start_open="true">
      <refonte-button
        class="mx-5 mb-1 mt-3 !bg-refonte-e-learning"
        v-bind:icon_left="IconOpenNewTab"
        v-if="
          detail.produitLienElearning && detail?.moduleElearning?.accessible
        "
        v-bind:on_click="openElearningModule">
        Accéder au module
      </refonte-button>
      <template
        v-if="
          detail.moduleElearning && detail?.moduleElearning.cours.length > 0
        ">
        <refonte-table
          key="cours-1"
          table_index="cours-1"
          v-bind:columns="columnsModuleElearning"
          v-bind:data="detail?.moduleElearning?.cours">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>

    <refonte-collapse
      v-if="
        detail.titre &&
        detail?.support?.supports &&
        detail?.support?.supports?.length > 0
      "
      class="mt-[12px]"
      v-bind:title_icon="IconTestValidation"
      title="Supports pédagogiques"
      v-bind:start_open="true">
      <template v-if="detail.support && detail?.support.supports.length > 0">
        <refonte-table
          key="supports-1"
          table_index="supports-1"
          v-bind:columns="columnsSupports"
          v-bind:data="detail?.support?.supports">
        </refonte-table>
        <refonte-button
          v-if="supportWithUrl > 1"
          class="item-convention-content-download"
          variant="secondary"
          v-bind:icon_left="IconDownload"
          v-on:click="
            () =>
              downloadSupportsZip(detail?.commandeId, detail?.sessionReference)
          "
          >Télécharger tous les fichiers (.zip)
        </refonte-button>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>

    <refonte-collapse
      v-if="detail.documents && detail?.documents?.length > 0"
      class="mt-[12px]"
      v-bind:title_icon="IconTestValidation"
      title="Autres ressources "
      v-bind:start_open="true">
      <template v-if="detail.documents && detail?.documents?.length > 0">
        <refonte-table
          key="documents-1"
          table_index="documents-1"
          v-bind:columns="columnsDocuments"
          v-bind:data="detail?.documents"
          class="table-no-space-between">
          >
        </refonte-table>
        <refonte-button
          v-if="docWithUrl > 1"
          class="item-convention-content-download mx-5"
          variant="secondary"
          v-bind:icon_left="IconDownload"
          v-on:click="() => downloadDocumentsZip(detail?.id)">
          Télécharger tous les fichiers (.zip)
        </refonte-button>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && detail.formations && detail.formations.length"
      class="mt-[12px]"
      v-bind:title_icon="IconFormations"
      title="Modules"
      v-bind:start_open="true">
      <template v-if="detail.formations.length">
        <refonte-table
          v-bind:on_details="goToDetailsFormation"
          key="formations-cursus-1"
          table_index="formations-cursus-1"
          v-bind:columns="columnsFormations"
          v-bind:data="detail.formations.map((f) => formatFormation(f))">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && detail.programmes && detail.programmes.length > 0"
      class="mt-[12px]"
      v-bind:title_icon="IconDayAgenda"
      title="Détails de la programmation">
      <template v-if="detail.programmes.length">
        <div
          v-for="(programme, index) in detail.programmes"
          class="mx-5"
          v-bind:key="`programme-${index}`">
          <refonte-separator
            v-if="index > 0 && detail.programmes.length > 1"
            class="px-[12px]" />
          <refonte-label
            v-if="programme.titre && detail.programmes.length > 1"
            v-bind:label="programme.titre"
            class="px-[16px]" />
          <refonte-table
            v-if="programme?.prestations && programme?.prestations?.length > 0"
            key="prestations-1"
            table_index="prestations-1"
            v-bind:columns="columnsPrestations"
            v-bind:data="
              programme?.prestations?.map((p: Prestation) => ({
                ...p,
                nom: p.nom ? p.nom : p.typeId == 2 ? 'Repas' : p.titre,
                lieuNom: p.site ? p.site.denomination : undefined
              }))
            ">
          </refonte-table>
        </div>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <formations-convocation-modal
      v-bind:ressource_base_url="`participant/commande/${detail.commandeId}/formation/${detail.sessionReference}`"
      v-bind:show="convocation_modal"
      v-if="convocation_modal && !loading"
      v-bind:on_close="closeConvocationModal" />
    <formations-map-modal
      v-bind:show="map_modal"
      v-bind:adresse="addresse"
      v-bind:coordinates="coordinates"
      v-bind:on_close="closeMapModal" />
  </template>
  <spinner
    v-else
    sizes="w-20 h-20"
    thickness="border-8" />
  <RefonteModalPositionnementParticipant
    v-if="isParticipantPositionnementModalOpen"
    v-bind:show="isParticipantPositionnementModalOpen"
    v-bind:on_complete="fetchFormationDetail"
    v-bind:on_close="closeParticipantPositionnementModal"
    v-bind:formation="detail" />
  <RefonteModalValidationAcquisParticipant
    v-if="isParticipantValidationAquisModalOpen"
    v-bind:show="isParticipantValidationAquisModalOpen"
    v-bind:on_close="closeParticipantValidationAcquisModal"
    v-bind:on_complete="fetchFormationDetail"
    v-bind:formation="detail" />
  <RefonteModalQuestionnaireSatisfactionParticipant
    v-if="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:show="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:on_close="closeParticipantQuestionnaireSatisfactionModal"
    v-bind:on_complete="fetchFormationDetail"
    v-bind:formation="detail" />
  <refonte-modal-appreciation
    v-bind:show="isParticipantAppriciationModalOpen"
    v-bind:on_close="closeAppreciationModal"
    v-bind:elearning="detail?.type?.id === 2" />
  <examen-modal
    v-if="examenModalShow"
    v-bind:modal_show="examenModalShow"
    v-bind:onclose="closeExamenModal"
    v-bind:session="computeSession(detail)"
    v-bind:fetch_session="fetchFormationDetail" />
</template>
<script setup lang="ts">
  import Spinner from '@/components/utils/spinner.vue';
  import { computed, h, onMounted, ref, watch } from 'vue';
  import IconLocation from '@/assets/img/refonte/icons/information/icon-location.svg?component';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconDayAgenda from '@/assets/img/refonte/icons/information/icon-day-agenda.svg?component';
  import IconCatalogue from '@/assets/img/refonte/icons/menu/icon-catalogue.svg?component';
  import IconTestValidation from '@/assets/img/refonte/icons/information/icon-test-validation.svg?component';
  import IconInformation from '@/assets/img/refonte/icons/information/icon-information.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import RefonteSearchResultsEmpty from '@/components/refonte/inputs/refonte-search-results-empty.vue';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import RefonteTable from '@/components/refonte/tables/refonte-table.vue';
  import { API } from '@/http-common';
  import dates_helpers from '@/mixin/dates_helpers';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import RefonteItemFile from '@/components/refonte/items/refonte-item-file.vue';
  import { useRoute, useRouter } from 'vue-router';
  import FormationsDetailsMain from '@/views/_espace/_refonte/participant/_formations-details/formations-details-main.vue';
  import {
    FormationsDetail,
    Prestation,
    SatisfactionStatus,
    Support,
    Synthese,
    TestPositionnementStatus,
    TestValidationStatus
  } from '@/types/participant/formations-details-types';
  import FormationsConvocationModal from '@/views/_espace/_refonte/participant/_formations-details/formations-convocation-modal.vue';
  import ValidationAquisCell from '@/components/refonte/tables/refonte-table-participant-formation-test-validation-aquis.vue';
  import ExamenCell from '@/components/refonte/tables/refonte-table-participant-formation-examen.vue';
  import IconModify from '@/assets/img/refonte/icons/action/icon-modify.svg?component';
  import RefonteModalPositionnementParticipant from '@/components/refonte/modals/refonte-modal-positionnement-participant.vue';
  import RefonteModalValidationAcquisParticipant from '@/components/refonte/modals/refonte-modal-validation-acquis-participant.vue';
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import RefonteModalQuestionnaireSatisfactionParticipant from '@/components/refonte/modals/refonte-modal-questionnaire-satisfaction-participant.vue';
  import {
    downloadAttestationParticipant,
    downloadDocument,
    downloadDocumentsZip,
    downloadSupportFormation,
    downloadSupportsZip
  } from '@/mixin/participant_download_functions';
  import FormationsMapModal from '@/views/_espace/_refonte/participant/_formations-details/formations-map-modal.vue';
  import RefonteModalAppreciation from '@/components/refonte/modals/refonte-modal-appreciation.vue';
  import {
    buildProduitTypeLabel,
    buildProduitTypeShortcut
  } from '@/stores/utils';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { Inscription } from '@/types/gestion/inscriptions-types';
  import IconFormations from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import examenModal from '@/views/_espace/_entreprise/_sessions/_modal/examen-modal.vue';

  const examenModalShow = ref<boolean>(false);
  const computeSession = (detail: FormationsDetail | undefined) => {
    if (detail) {
      return {
        sessionDates: [{ date: detail.dateDebut }, { date: detail.dateFin }],
        participantId: detail.id,
        examen: detail.examen,
        titre: detail.titre,
        type: detail.type
      };
    } else {
      return {};
    }
  };
  const closeExamenModal = () => {
    examenModalShow.value = false;
  };
  const openExamenModal = () => {
    if (detail?.value?.examen?.id && !detail.value?.examen?.termine) {
      examenModalShow.value = true;
    }
  };
  const map_modal = ref<boolean>(false);
  const addresse = ref<string>('');
  const coordinates = ref<string>('');
  const openMapModal = (newAddresse: string, newCoordinates: string) => {
    addresse.value = newAddresse;
    coordinates.value = newCoordinates;
    map_modal.value = true;
  };
  const router = useRouter();
  const closeMapModal = () => {
    map_modal.value = false;
  };

  const detail = ref<FormationsDetail>();
  const route = useRoute();
  const loading = ref<boolean>(false);
  const id = computed(() => route.query.id);
  const produitId = computed(() => route.query.produitId);
  const convocation_modal = ref<boolean>(false);
  const isParticipantValidationAquisModalOpen = ref<boolean>(false);
  const isParticipantPositionnementModalOpen = ref<boolean>(false);
  const isParticipantQuestionnaireSatisfactionModalOpen = ref<boolean>(false);
  const isParticipantAppriciationModalOpen = ref<boolean>(false);

  function openParticipantPositionnementModal() {
    isParticipantPositionnementModalOpen.value = true;
  }

  function closeParticipantPositionnementModal() {
    isParticipantPositionnementModalOpen.value = false;
  }

  function openParticipantValidationAcquisModal() {
    isParticipantValidationAquisModalOpen.value = true;
  }

  function closeParticipantValidationAcquisModal() {
    isParticipantValidationAquisModalOpen.value = false;
  }

  function openParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = true;
  }

  function closeParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = false;
  }

  watch(
    () => route.query.id,
    () => loadFormationDetail()
  );
  watch(
    () => route.query.produitId,
    () => loadFormationDetail()
  );
  const openConvocationModal = () => {
    convocation_modal.value = true;
  };

  const closeConvocationModal = () => {
    convocation_modal.value = false;
  };

  const closeAppreciationModal = () => {
    isParticipantAppriciationModalOpen.value = false;
  };
  const fetchFormationDetail = async () => {
    if (id.value) {
      const response = await API.get(
        `/participant/v2/formations/session/${id.value}/details`,
        {
          params: {
            produitId: produitId.value
          }
        }
      );

      if (response && response.data) {
        detail.value = mapFormationDetail(response.data);
      }
    }
  };

  const loadFormationDetail = async () => {
    loading.value = true;
    await fetchFormationDetail();
    loading.value = false;
  };

  const goToDetailsFormation = (row: FormationsDetail) => {
    const currentProduitId = produitId.value || row.produitId;
    router.push({
      path: '/inscription/formations-details',
      query: {
        id: row.id,
        produitId: currentProduitId
      }
    });
  };

  const mapSupport = (support, detail) => ({
    ...support,
    supportLabel: 'Télécharger',
    reference: detail.sessionReference,
    sessionId: detail.sessionId,
    commandeId: detail.commandeId,
    parcoursProduitId: detail.isSousProduitParcours
      ? detail.produitId
      : undefined,
    participantId: detail.id,
    type: detail.type
  });

  const mapDocument = (document, detail) => {
    const label = document.url ? 'Télécharger' : document.lien ? 'Accéder' : '';
    return {
      ...document,
      documentLabel: label,
      participantId: detail.id
    };
  };

  const mapFormationDetail = (detail) => ({
    ...detail,
    support: detail?.support?.supports
      ? {
          ...detail.support,
          supports: detail.support.supports.map((s) => mapSupport(s, detail))
        }
      : detail?.support,
    documents: detail?.documents?.map((doc) => mapDocument(doc, detail)),
    typeShortcut: buildProduitTypeShortcut(
      detail.type.id,
      detail.produitLienElearning
    ),
    typeLabel: buildProduitTypeLabel(
      detail.type.label,
      detail.produitLienElearning
    )
  });

  onMounted(async () => {
    await loadFormationDetail();
  });

  const columnsPrestations = [
    {
      content_index: 'nom',
      date: 'date',
      width: 308
    },
    {
      content_index: 'heureDebut',
      label: 'Heure de début',
      width: 120,
      content_custom: (row: Prestation) =>
        h('div', dates_helpers.methods.formatMinutesToHours(row.heureDebut)),
      content_sub_text: () => detail?.value?.fuseauHoraire || ''
    },
    {
      content_index: 'heureFin',
      label: 'Heure de fin',
      width: 120,
      content_custom: (row: Prestation) =>
        h('div', dates_helpers.methods.formatMinutesToHours(row.heureFin)),
      content_sub_text: () => detail?.value?.fuseauHoraire || ''
    },
    {
      content_index: 'dureeMinutes',
      label: 'Durée',
      width: 90,
      content_custom: (row: Prestation) =>
        h('span', {
          innerHTML: row.dureeMinutes
            ? dates_helpers.methods.formatMinutesToHours(row.dureeMinutes)
            : '-'
        })
    },
    {
      content_index: 'lieuNom',
      label: 'Site',
      width: 150,
      content_icon: (row: Prestation) => row.site?.coordinates && IconLocation,
      class: (row: Prestation) =>
        row.site?.coordinates
          ? '!flex-grow-0'
          : '!flex-grow-0 !bg-white !cursor-default !pointer-events-none',
      on_click: (row: Prestation) => {
        if (row.site?.coordinates) {
          openMapModal(concatAdress(row?.site), row?.site?.coordinates);
        }
        return undefined;
      }
    }
  ];

  const concatAdress = (site) => {
    return `${site.denomination} - ${site.numeroVoie}, ${site.codePostal} ${site.ville}`;
  };

  const columnsSynthese = computed(() => [
    {
      content_index: 'inscription',
      label: 'Inscription',
      width: 120,
      content_custom: (row: Synthese) =>
        h('span', {
          innerHTML: row.inscription.label
        })
    },
    ...(detail.value?.synthese?.statutElearning
      ? [
          {
            content_index: 'statutElearning',
            label: 'Statut Elearning',
            width: 150
          }
        ]
      : []),
    ...(detail.value?.synthese.presence
      ? [
          {
            content_index: 'presence',
            label: 'Présence',
            width: 140,
            label_icon: IconInformation,
            label_icon_tooltip:
              "La saisie des présences nécessite une action du gestionnaire de formation, à l'issue de la formation. La saisie n'est pas immédiate. L'attestation de formation ne sera générée que lorsque la présence effective sera saisie.",
            content_custom: (row: Synthese) =>
              h('span', {
                innerHTML: row.presence.label
              })
          }
        ]
      : []),
    ...(detail.value?.synthese.positionnement
      ? [
          {
            content_index: 'positionnement',
            label: 'T. Positionnement',
            width: 140,
            content_icon: (row: Synthese) => {
              const id = row.positionnement?.id;
              if (id === TestPositionnementStatus.A_REALISE) return IconModify;
              if (id === TestPositionnementStatus.REALISE)
                return IconValidate20Green;
              return null;
            },
            content_custom: (row: Synthese) =>
              h('span', {
                innerHTML: row.positionnement.label
              }),
            on_click: (row: Synthese) => {
              if (
                row.positionnement?.id === TestPositionnementStatus.A_REALISE
              ) {
                openParticipantPositionnementModal();
              }
            },
            on_click_disabled: (row: Synthese) =>
              row.positionnement?.id !== TestPositionnementStatus.A_REALISE,
            class: (row: Synthese) =>
              row.positionnement?.id === TestPositionnementStatus.A_REALISE
                ? 'btn-border'
                : ''
          }
        ]
      : []),
    ...(detail?.value?.synthese?.validation
      ? [
          {
            content_index: 'validation',
            label: detail?.value?.synthese?.validation.testIntermediaire
              ? 'Test intermédiaire'
              : 'T. valid. acquis',
            label_icon: IconInformation,
            label_icon_tooltip:
              "À l'issue de la session, si vous réalisez votre test au-delà de 8 jours, l'attestation de formation sera automatiquement générée avec la mention \"Résultat de l'évaluation des acquis : non réalisé\". Au-delà de ce délai, vous pouvez réaliser le test à titre d'auto-évaluation, mais l'attestation de formation ne sera pas mise à jour automatiquement.",
            width: 120,
            content_icon: (row: Synthese) =>
              row.validation?.id === TestValidationStatus.A_REALISE ||
              (row.validation?.nombreTentativesRestantes &&
                row.validation?.nombreTentativesRestantes > 0)
                ? IconModify
                : null,
            content_custom: (row: Synthese) => h(ValidationAquisCell, { row }),
            on_click: (row: Synthese) => {
              if (
                row.validation?.id === TestValidationStatus.A_REALISE ||
                (row.validation?.nombreTentativesRestantes &&
                  row.validation?.nombreTentativesRestantes > 0)
              ) {
                openParticipantValidationAcquisModal();
              }
            },
            on_click_disabled: (row: Synthese) =>
              row.validation?.id !== TestValidationStatus.A_REALISE &&
              !row.validation?.nombreTentativesRestantes,
            class: (row: Synthese) =>
              row.validation?.id === TestValidationStatus.A_REALISE ||
              (row.validation?.nombreTentativesRestantes &&
                row.validation?.nombreTentativesRestantes > 0)
                ? 'btn-border'
                : ''
          }
        ]
      : []),
    {
      content_index: 'satisfaction',
      label: 'Satisfaction',
      width: 120,
      content_custom: (row: Synthese) =>
        h('span', {
          innerHTML: row.satisfaction ? row.satisfaction.label : '-'
        }),
      content_icon: (row: Synthese) => {
        const id = row.satisfaction?.id;
        if (id === SatisfactionStatus.A_REALISE) return IconModify;
        if (id === SatisfactionStatus.REALISE) return IconValidate20Green;
        return null;
      },
      on_click: (row: Synthese) => {
        if (row.satisfaction?.id === SatisfactionStatus.A_REALISE) {
          openParticipantQuestionnaireSatisfactionModal();
        }
      },
      on_click_disabled: (row: Synthese) =>
        row.satisfaction?.id !== SatisfactionStatus.A_REALISE,
      class: (row: Synthese) =>
        row.satisfaction?.id === SatisfactionStatus.A_REALISE
          ? 'btn-border'
          : ''
    },
    ...(detail?.value?.examen && detail?.value?.examen.id
      ? [
          {
            content_index: 'examen',
            label: 'Examen',
            width: 120,
            content_icon: () => (isExamenAccesible.value ? IconModify : null),
            content_custom: () =>
              h(ExamenCell, { examen: detail?.value.examen }),
            on_click: (row: Synthese) => {
              if (isExamenAccesible.value) {
                openExamenModal();
              }
            },
            is_pending: () => !isExamenAccesible.value,
            class: (row: Synthese) =>
              isExamenAccesible.value ? 'btn-border' : ''
          }
        ]
      : [])
  ]);

  const isExamenAccesible = computed(
    () =>
      detail?.value?.examen &&
      detail?.value?.examen.id &&
      !detail?.value?.examen.termine &&
      !detail?.value?.examen.expire
  );

  const columnsModuleElearning = [
    {
      content_index: 'titre',
      label: 'Titre',
      width: 150
    },
    {
      content_index: 'statutString',
      label: 'Statut',
      width: 150
    }
  ];

  const columnsSupports = [
    {
      content_index: 'titre',
      label: 'Titre',
      width: 150
    },
    {
      content_index: 'portailLabel',
      label: 'Type',
      width: 150
    },
    {
      content_index: 'version',
      label: 'Version',
      width: 150
    },
    {
      content_index: 'modifiedDate',
      label: 'Mise à jour',
      width: 150
    },
    {
      content_index: 'endDisponibiliteDate',
      label: "Disponible jusqu'au",
      width: 150
    },
    {
      content_index: 'supportLabel',
      label: 'Support',
      min_width: 140,
      width: 170,
      content_icon: () => IconDownload,
      class: () => '!flex-grow-0 btn-border',
      on_click: async (row: Support) => {
        const result = await downloadSupportFormation(row);
        if (result?.appreciationRequired) {
          isParticipantAppriciationModalOpen.value = true;
        }
      }
    }
  ];

  const columnsDocuments = [
    {
      content_index: 'titre',
      label: 'Titre',
      width: 280
    },
    {
      content_index: 'modifiedDate',
      label: 'Mise à jour',
      width: 270
    },
    {
      content_index: 'documentLabel',
      label: 'Support',
      min_width: 140,
      width: 170,
      content_icon: (row: Support) =>
        row.documentLabel === 'Télécharger' ? IconDownload : IconOpenNewTab,
      class: () => '!flex-grow-0 btn-border',
      on_click: async (row: Support) => {
        if (row.documentLabel === 'Télécharger' && row.url) {
          downloadDocument(row);
        } else if (row.documentLabel === 'Accéder' && row.lien) {
          window.open(row.lien, '_blank');
        }
      }
    }
  ];
  const columnsFormations = [
    {
      content_index: 'titre',
      tags_type: 'typeShortcut',
      tags_type_label: 'typeLabel',
      content_sub_text: (row: Inscription) =>
        `${row.modeLabel === 'Intra' ? `${row.modeLabel} - ` : ''}${row.lieu ?? ''}`,
      width: 308
    },
    {
      content_index: 'datesFormations',
      label: 'Dates de formation',
      width: 190
    },
    {
      content_index: 'statutLabel',
      label: 'Statut',
      width: 85,
      content_custom: (row: Inscription) =>
        h('span', {
          innerHTML: row.statutLabel,
          class:
            row.statutLabel === 'Annulé' || row.statutLabel === 'Transféré'
              ? 'text-jinius-red'
              : ''
        })
    },
    {
      content_index: 'lieu',
      label: 'Site',
      width: 85
    },
    {
      content_index: 'presence',
      label: 'Présence',
      width: 85,
      content_custom: (row: Inscription) =>
        h('span', {
          innerHTML: row.presence?.label ?? '-'
        })
    },
    {
      content_index: 'attestationLabel',
      label: 'Attestation',
      min_width: 117,
      width: 130,
      on_click: async (row: Inscription) => {
        if (row.attestationId) {
          downloadAttestationParticipant(row.attestationId);
        }
      },
      content_icon: (row: Inscription) => row.attestationId && IconDownload,
      class: (row: Inscription) =>
        row.attestationId ? '!flex-grow-0 btn-border' : '!flex-grow-0'
    }
  ];
  const openElearningModule = async () => {
    let response;
    if (!produitId.value) {
      response = await API.get(
        `/participant/v2/formations/session/${id.value}/elearning`,
        {
          headers: { 'SKIP-REDIRECTION': true }
        }
      );
    } else {
      response = await API.get(
        `/participant/v2/formations/session/${id.value}/parcours/${produitId.value}/elearning`,
        {
          headers: { 'SKIP-REDIRECTION': true }
        }
      );
    }

    if (response && response.data && response.data.url) {
      window.open(response.data.url);
    }
  };

  const formatFormation = (f) => {
    let dates = '-';
    if (f.dateDebut && f.dateFin) {
      if (f.dateDebut == f.dateFin) {
        dates = `${f.dateDebut}`;
      } else {
        dates = `${f.dateDebut} - ${f.dateFin}`;
      }
    }
    return {
      ...f,
      datesFormations: dates,
      disabled: f.sessionStatut?.id === 5,
      typeShortcut: addSessionTypeShortcut(
        buildProduitTypeShortcut(f.type.id, f.lienElearning),
        f.sessionStatut?.id
      ),
      typeLabel: addSessionTypeLabel(
        buildProduitTypeLabel(f.type.label, f.lienElearning),
        f.sessionStatut?.id
      ),
      attestationLabel: f.attestationId ? 'Télécharger' : '-'
    };
  };
  const addSessionTypeLabel = (flags: string[], sessionStatutId: number) => {
    return sessionStatutId === 5 ? [...flags, 'Annulée'] : flags;
  };

  const addSessionTypeShortcut = (flags: string[], sessionStatutId: number) => {
    return sessionStatutId === 5 ? [...flags, 'annulee'] : flags;
  };

  const docWithUrl = computed(() =>
    detail.value?.documents
      ? detail.value.documents.filter((doc) => doc.url != null).length
      : 0
  );

  const supportWithUrl = computed(() =>
    detail.value?.support?.supports
      ? detail.value.support.supports.filter((doc) => doc.url != null).length
      : 0
  );
</script>

<style lang="scss" scoped>
  .table-no-space-between {
    :deep(.table-row-content) {
      justify-content: flex-start !important;

      .refonte-table-item {
        flex-grow: 0 !important;
      }
    }
  }
  :deep(.btn-border) {
    border-width: 1px;
    border-color: rgb(164 189 218);
    border-radius: 8px;
  }
</style>
